import React from "react";
import {
  ErrorBoundary as ErrorBoundaryWrapper,
  FallbackProps,
} from "react-error-boundary";
import Alert from "components/Alert";
import * as Sentry from "@sentry/react";

interface ErrorBoundaryProps {
  children?: React.ReactNode;
  fallbackComponent?: React.ComponentType<FallbackProps>;
}

// component displayed when child component has exception occur
const ErrorFallback = () => {
  return (
    <Alert
      msg="Something went wrong. Please try again later."
      type="error"
      // Alert has no `className` prop, but the original JS passed one here;
      // preserved verbatim to avoid changing behavior.
      // @ts-expect-error -- `className` not in AlertProps, kept as-is
      className="icon-error-boundary"
    />
  );
};

const ErrorBoundary = ({
  children,
  fallbackComponent = ErrorFallback,
}: ErrorBoundaryProps) => {
  return (
    <ErrorBoundaryWrapper
      FallbackComponent={fallbackComponent}
      // `className` is not part of react-error-boundary's props, but the original
      // JS passed one here; preserved verbatim to avoid changing behavior.
      // @ts-expect-error -- `className` not in ErrorBoundaryProps, kept as-is
      className="icon-error-boundary"
      // can remove this probably unless there is a way to leverage this with sentry for better telemetry
      onError={(err) => {
        Sentry.captureException(err);
        console.error(err);
      }}
    >
      {children}
    </ErrorBoundaryWrapper>
  );
};

export default ErrorBoundary;
